import React from 'react'

import { AlignItems, Box, Display } from '@gousto-internal/citrus-react'
import classnames from 'classnames'

import type { Recipe } from '@library/menu-service'
import type { MenuRecipe } from '@library/menu-service/queries/menuApiMenuRecipe/types'

import { RecipeAttributePill } from '../../RecipeAttributePill/RecipeAttributePill'
import { replaceDashWithUnderscore, formatDietaryText, formatShelfLifeText } from './formatters'

import css from './RecipeAttributes.css'

type RecipeAttributesPillsProps = {
  fiveADay?: Recipe['fiveADay']
  shelfLife: Recipe['shelfLife']
  dietaryClaims?: Recipe['dietaryClaims']
  equipments?: MenuRecipe['equipment']
  loading?: boolean
}

const LoadingSkeleton = ({ style }: { style?: React.CSSProperties }) => (
  <span className={css.loadingSkeleton} style={style} data-testid="LoadingSkeleton" />
)

export const RecipeAttributesPills = ({
  dietaryClaims,
  equipments,
  shelfLife,
  fiveADay,
  loading,
}: RecipeAttributesPillsProps) => {
  if (loading) {
    return (
      <div className={classnames(css.attributes)}>
        {[...Array(4)].map(() => (
          <LoadingSkeleton key={Math.random()} style={{ height: '10px', marginBottom: '10px' }} />
        ))}
      </div>
    )
  }

  if (!dietaryClaims?.length && !shelfLife && !equipments?.length) {
    return null
  }

  return (
    <Box
      alignItems={AlignItems.FlexStart}
      wrap
      data-testid="RecipeAttributesPills"
      display={Display.Flex}
    >
      {dietaryClaims &&
        dietaryClaims?.length > 0 &&
        dietaryClaims?.map(({ slug, name }) => (
          <RecipeAttributePill
            key={slug}
            icon={replaceDashWithUnderscore(slug)}
            text={formatDietaryText(name)}
          />
        ))}

      {!!fiveADay && <RecipeAttributePill icon="5_a_day" text={`${fiveADay}/5 a day`} />}

      {shelfLife && (
        <RecipeAttributePill icon="calendar" text={formatShelfLifeText(shelfLife?.maxDays)} />
      )}

      {equipments &&
        equipments?.length > 0 &&
        equipments.map(({ name }) => (
          <RecipeAttributePill key={name} icon="equipment" text={name} />
        ))}
    </Box>
  )
}
